<template>
  <div class="testpaper" ref="exambody">
    <div class="header">
      <div class="contain header_wrap">
        <div class="icon">
          <img src="../../assets/icons/icon.png" alt>
        </div>
        <div class="title">
          {{message.examtitle}}
          <div class="record">
            <span>
              总分
              <em>{{message.epscore}}</em>
              分
            </span>
            <span>
              剩余考试时间：
              <em>{{m}}</em>
              分
              <em>{{s}}</em>
              秒
            </span>
            <span>
              已答题
              <span style="color:red">{{ehuseranswer|toNumber}}</span>
              /{{message.epcount}}
            </span>
          </div>
        </div>
        <div class="back" @click="subimt">提交试卷</div>
      </div>
    </div>
    <div class="div"></div>
    <div class="main contain_main issuelist">
      <div class="issueitem" v-for="(issuelist,index) in list" :key="'issue'+index">
        <div class="title">
          {{issuelist.title}}
          <!-- <span>（共4题，20分）</span> -->
        </div>
        <issue
          v-for="(item,order) in issuelist.questions"
          @sure="sure"
          :key="'question'+order"
          :total="issuelist.questions.length"
          :order="(order+1)"
          :message="item"
          :showasw="false"
        ></issue>
      </div>
    </div>
    <div style="height:300px"></div>
  </div>
</template>
<script>
import issue from "../../components/issue";
import { getsession, ExamAnswer_add } from "../../assets/js/api.js";
import { setInterval, clearTimeout, setTimeout } from "timers";
export default {
  name: "testpaper",
  data() {
    return {
      list: [],
      message: {
        epcount: "",
        epitem: "",
        epscore: "",
        examcue: "",
        examdecide: "",
        examscore: "",
        examtime: "",
        examtitle: ""
      },
      timename: null,
      m: null,
      s: null,
      ehuseranswer: [],
      actFunc: true,
      warning: 0
    };
  },
  components: {
    issue
  },
  filters: {
    toNumber(value) {
      return value.filter(item => {
        return item.questionanswer;
      }).length;
    }
  },
  // beforeRouteEnter (to, from, next) {
  //   document.addEventListener("visibilitychange", this.visibilitychanged);
  //   next()
  // },
  beforeMount() {
    this.getdata();
  },
  mounted() {
    window.onbeforeunload = function(event) {
      return "信息";
    };
    this.actFunc = true;
    document.addEventListener("visibilitychange", this.visibilitychanged);
    // this.$refs.exambody.addEventListener("mouseleave", () => {
    //   this.warning++;
    //   alert(
    //     "您已触发警告" + this.warning + "次，请您鼠标不要离开考试界面,认真答题!"
    //   );
    //   this.getdata();
    // });
  },
  destroyed() {
    clearTimeout(this.timename);
    this.timename = null;
    this.actFunc = false;
    window.removeEventListener("visibilitychang", this.visibilitychanged);
    return true;
  },
  beforeRouteLeave(to, from, next) {
    clearTimeout(this.timename);
    window.removeEventListener("visibilitychang", this.visibilitychanged);
    this.actFunc = false;
    this.timename = null;
    next();
  },
  methods: {
    // 监听加载
    visibilitychanged() {
      if (this.actFunc) {
        this.getdata();
      }
    },
    // 全屏展示
    handleFullScreen() {
      var element = document.documentElement;
      if (element.requestFullscreen) {
        element.requestFullscreen();
      } else if (element.msRequestFullscreen) {
        element.msRequestFullscreen();
      } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen();
      } else if (element.webkitRequestFullscreen) {
        element.webkitRequestFullscreen();
      }
    },
    getdata() {
      getsession().then(res => {
        if (res.data.code == 200) {
          // 试卷题目数据矫正
          if (!res.data.data.ehquestion[0].title) {
            this.list = [
              { title: "试题", questions: res.data.data.ehquestion }
            ];
          } else {
            this.list = res.data.data.ehquestion;
          }
          // 试卷答案预导入
          if (window.sessionStorage.getItem("ehuseranswer")) {
            this.ehuseranswer = JSON.parse(
              window.sessionStorage.getItem("ehuseranswer")
            );
          } else {
            this.ehuseranswer = [];
            this.list.forEach(item => {
              item.questions.forEach(quest => {
                if (quest.questiontype == 0) {
                  this.ehuseranswer.push({
                    questionid: quest.questionid,
                    questionanswer: "段落说明"
                  });
                } else {
                  this.ehuseranswer.push({
                    questionid: quest.questionid,
                    questionanswer: ""
                  });
                }
              });
            });
          }
          // 试卷与试卷答案合并
          var map = new Map();
          this.ehuseranswer.forEach(item => {
            map.set(item.questionid, item.questionanswer);
          });
          this.list = this.list.map(item => {
            item.questions = item.questions.map(quest => {
              quest.questionanswer = map.get(quest.questionid);
              return quest;
            });
            return item;
          });
          // 试卷头设置数据
          this.message = res.data.data.ehsetting;
          this.settimeout(res.data.data.examendtime);
        } else if (res.data.code == 205) {
          this.$Notice.warning({ title: "信息提示", desc: res.data.message });
          this.$router.go(-1);
        } else {
          this.$Notice.warning({ title: "信息提示", desc: res.data.message });
        }
      });
    },
    // timeattention(data) {
    //   var time = new Date();
    //   this.settimeout(data - Math.round(time.getTime() / 1000));
    // },
    settimeout(time) {
      var time = time - 1;
      this.m = Math.floor(time / 60);
      this.s = time % 60;
      clearTimeout(this.timename);
      this.timename = null;
      if (time <= 2) {
        this.m = 0;
        this.s = 0;
        this.submitact("已经自动提交试卷！");
        return;
      }

      clearTimeout(this.timename);
      this.timename = setTimeout(() => {
        this.settimeout(time);
      }, 1000);
    },
    sure(data) {
      this.ehuseranswer = this.ehuseranswer.map(item => {
        if (item.questionid == data.questionid) {
          return data;
        } else {
          return item;
        }
      });

      window.sessionStorage.setItem(
        "ehuseranswer",
        JSON.stringify(this.ehuseranswer)
      );
    },
    submitact(sub) {
      ExamAnswer_add({ ehuseranswer: this.ehuseranswer }).then(res => {
        if (sub) {
          alert(sub);
        }
        clearTimeout(this.timename);
        this.timename = null;
        if (res.data.code == 200) {
          if (res.data.data.examdecide == "1") {
            this.$router.push({
              name: "scorelist",
              params: {
                message: res.data.data
              }
            });
          } else {
            this.$router.push({
              name: "submit",
              params: {
                message: res.data.data
              }
            });
          }
          window.sessionStorage.removeItem("ehuseranswer");
        } else {
          this.$Notice.warning({ title: "信息提示", desc: res.data.message });
        }
      });
    },
    subimt() {
      // var ehitem =
      //   this.list.some(item => {
      //     item.questionitem == 1;
      //   }) - 0;
      var check = this.ehuseranswer.some(item => {
        return item.questionanswer == "";
      });
      if (!confirm((check ? "有题未作答！" : "") + "您确定要提交试卷吗？")) {
        return;
      }
      this.submitact();
    }
  }
};
</script>
<style lang="css" scoped>
.header {
  height: 0.75rem;
  width: 100%;
  border: 1px solid #e8e9ee;
  background: #fff;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
}
.header .title {
  min-width: 200px;
}
.div {
  display: block;
  content: "";
  height: 0.75rem;
  border: #474dff 1px solid;
}
.header_wrap {
  display: flex;
  justify-content: space-between;
  line-height: 0.75rem;
}
.record {
  position: absolute;
  bottom: 0rem;
  left: 50%;
  transform: translateX(-50%);
  font-size: 0.12rem;
  line-height: 0.2rem;
  width: 200%;
  color: #333;
  display: flex;
  justify-content: space-around;
}
em {
  color: red;
}
.issuelist {
  user-select: none;
  -webkit-user-select: none;
}
.header_wrap .title {
  font-size: 0.26rem;
  color: #474dff;
  position: relative;
}
.header_wrap .back {
  width: 1.1rem;
  height: 0.3rem;
  border-radius: 0.03rem;
  color: #fff;
  background: #5b61ff;
  font-size: 0.16rem;
  display: inline-block;
  line-height: 0.3rem;
  margin-top: 0.22rem;
}
.main .title {
  font-size: 0.24rem;
  text-align: left;
  margin-top: 0.6rem;
}
.title span {
  font-size: 0.12rem;
  color: "#777f90";
}
</style>


// WEBPACK FOOTER //
// src/pages/testlists/testpaper.vue